import React from 'react';
import '../css/Skills.css';
import settings from '../img/settings.png';
import design from '../img/design.png';
import tools from '../img/tools.png';
import light from '../img/light.png';
import fontAwsome from '../img/fontAwsome.png';
import bootstrap from '../img/bootstrap.png';
import materialUI from '../img/materialUi.svg';
import adobeXD from '../img/adobeXD.svg';
function Skills() {
    return (
        <div className="skills" id="skills">

            <div className="skills__development">
                <div className="skills__title">
                    <h1 className="animate__animated animate__shakeX animate__infinite">Skills</h1>
                    <hr />
                </div>
                <div className="skills__title2">
                    <img src={settings} alt="" />
                    <h1>DEVELOPMENT</h1>
                </div>
                <div className="rreshti">
                    <div className="colona"><p>HTML</p></div>
                    <div className="colona"><p>CSS</p></div>
                    <div className="colona"><p>JAVASCRIPT</p></div>
                </div>
                <div className="rreshti2">
                    <div className="colona"><p>REACT</p></div>
                    <div className="colona"><p>NODE.JS</p></div>
                    <div className="colona"><p>JAVA</p></div>
                </div>
                <div className="rreshti2">
                    <div className="colona"><p>MySQL</p></div>
                    <div className="colona"><p>FIREBASE</p></div>
                    <div className="colona"><p>PHP</p></div>
                </div>
            </div>
            <div className="skills__design">
                <div className="skills__title3">
                    <img src={design} alt="" />
                    <h1>DESIGN</h1>
                </div>
                <div className="skills__icons">
                    <img src={fontAwsome} alt="" />
                    <img src={bootstrap} alt="" />
                    <img src={materialUI} alt="" />
                    <img src={adobeXD} alt="" />
                </div>
                <div className="skills__tools">
                    <div className="tools">
                        <div className="tools__title">
                            <img src={tools} alt="" />
                            <h1>TOOLS</h1>
                        </div>

                        <ul>
                            <li>Git + Github</li>
                            <li>Command Line</li>
                            <li>Chrome DevTools</li>
                            <li>Material UI</li>
                            <li>Postman</li>
                        </ul>
                    </div>
                    <div className="knowledge">
                        <div className="tools__title">
                            <img src={light} alt="" />
                            <h1>KNOWLEDGE</h1>
                        </div>
                        <ul>
                            <li>CSS Detangling</li>
                            <li>ECMAScript 6</li>
                            <li>Usability</li>
                            <li> SEO</li>
                            <li>TDD</li>
                        </ul>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Skills;
